import _ from "lodash";
import { Module } from "vuex";
import { CurrentTemplateState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new CurrentTemplateState();

const namespaced: boolean = true;
const modul: Module<CurrentTemplateState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "template",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export default modul;
